"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWishlistCommandHandler = void 0;
const domain_1 = require("../domain");
class BaseWishlistCommandHandler {
    constructor(wishlistRepository) {
        this.wishlistRepository = wishlistRepository;
        this.wishlistStateValidator = new domain_1.WishlistStateValidator();
    }
    getWishlist(userId, expectedState) {
        return __awaiter(this, void 0, void 0, function* () {
            const wishlist = yield this.wishlistRepository.retrieveByUserId(userId);
            if (wishlist === null) {
                throw new domain_1.WishlistNotFound(userId);
            }
            this.wishlistStateValidator.validate(wishlist, expectedState);
            return wishlist;
        });
    }
    getCurrentDate() {
        return new Date();
    }
}
exports.BaseWishlistCommandHandler = BaseWishlistCommandHandler;
